var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconArrowDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow-down-short",
    width: 14.982,
    height: 14.98,
    viewBox: "0 0 14.982 14.98",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M10.438,17.187a1.07,1.07,0,0,1,1.515,0l5.661,5.664,5.662-5.664A1.071,1.071,0,1,1,24.791,18.7l-6.419,6.419a1.07,1.07,0,0,1-1.515,0L10.438,18.7a1.07,1.07,0,0,1,0-1.515Z",
    transform: "translate(-10.123 -10.456)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M17.945,10.125a1.07,1.07,0,0,1,1.07,1.07v10.7a1.07,1.07,0,1,1-2.14,0v-10.7A1.07,1.07,0,0,1,17.945,10.125Z",
    transform: "translate(-10.454 -10.125)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-arrow-down.ecbf8d78.svg";
export { ForwardRef as ReactComponent };